const NavBarNotificationIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 24" fill="none">
            <path
                d="M14.857 17.5821C16.7202 17.3947 18.5513 17.0301 20.3287 16.4949C18.8353 14.8273 17.9999 12.6707 18 10.4321V9.75C18 6.43629 15.3137 3.75 12 3.75C8.68629 3.75 6 6.43629 6 9.75V10.4322C6 12.7422 5.13533 14.8472 3.71265 16.495C5.46455 17.0224 7.29671 17.3877 9.14299 17.5823M14.857 17.5821C13.2536 17.7433 11.7464 17.7434 10.143 17.5823M14.857 17.5821C14.9499 17.8718 15 18.1801 15 18.5C15 20.1569 13.6569 21.5 12 21.5C10.3431 21.5 9 20.1569 9 18.5C9 18.1803 9.04996 17.872 9.14299 17.5823"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
export default NavBarNotificationIcon;
